import { useCallback, useState } from 'react';

import { URL_REPLACEMENT } from '$const';
import useAssets from '~hooks/useAssets';
import { AssetId } from '~modules/media-library/model/Asset';
import { isCanvaTemplate } from '~modules/media-library/model/AssetFactory';
import { post } from '~services/api/methods';
import { makeProgramaticallyLinkClick } from '~utils/link';

type CanvaIntroProps = {
  assetId: AssetId;
  onClose: () => void;
};

export function CanvaIntro({ assetId, onClose }: CanvaIntroProps) {
  const [skipIntro, setSkipIntro] = useState<boolean>(false);

  // get asset from store
  const { getAssetById } = useAssets();
  const asset = getAssetById(assetId);

  const onStart = useCallback(async () => {
    if (!asset || !isCanvaTemplate(asset)) return;

    if (skipIntro) {
      const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/canva/skip_intro`;
      await post(requestUrl, {});
    }

    const href =
      'https://www.canva.com/login?redirect=%2Fdesign%3Fcreate%3Dtrue%26template%3D' + asset.attributes.sourceId;
    makeProgramaticallyLinkClick({ href });

    onClose();
  }, [asset, onClose, skipIntro]);

  if (!asset) {
    return null;
  }

  if (asset && asset.actions.canva !== true) {
    return <>no permission. TODO: Message comes form Linde.</>;
  }

  return (
    <>
      <h3 className="mx-3 mb-4 py-2">How to use canva templates</h3>
      <div className="row w2p-info-toolboard mx-0">
        <div className="col-1">&nbsp;</div>
        <div className="col-2">
          <img src="/themes/custom/ebm-linde/public/images/copy.svg" alt="" />
        </div>
        <div className="col-9">
          <h2>Step 1</h2>
          <p>
            Click "Start" to create your own version of a template.
            <br />
            Assign a new title, short description and tags.
          </p>
          <p></p>
        </div>
      </div>

      <br />
      <div className="row w2p-info-toolboard mx-0">
        <div className="col-2">&nbsp;</div>
        <div className="col-10">
          <form className="mb-4">
            <input
              type="checkbox"
              id="form_show_intro"
              onChange={e => {
                setSkipIntro(e.target.checked === true);
              }}
            />
            <label htmlFor="form_show_intro">Don't show this message again</label>
          </form>
          <button onClick={() => onStart()} className="button c-button c-button--dark u-padding-horizontal-lg mb-4">
            Start
          </button>
        </div>
      </div>
    </>
  );
}
